
import CustomeIcon from "../components/CustomeIcon";
import Button from "../components/Button";
import React from "react";

const HowToNavigate = (props) => {
    //How to navigate popup visibility
    let howToNavigateState = props.howToNavigatePopupVisibility;
    let howToNavigateClasses = 'howToNavigate hide';
    howToNavigateState ? howToNavigateClasses = 'howToNavigate show' : howToNavigateClasses = 'howToNavigate hide';

    return (
        <div className={howToNavigateClasses}>
            <Button classList="howToNavigateBtn" clickFunction={props.howToNavigateFunc}>
                <CustomeIcon src="./images/howTonavIcon.svg" alt="How to navigate" classList="iconHowToNavigate"></CustomeIcon>
            </Button>
            <div className="howToNavigateContent">
                <h3>How to navigate</h3>
                <div className="description rotate">
                    <span className="text">ROTATE</span>
                    <CustomeIcon src="./images/rotate.svg" alt="How to navigate - Rotate" classList="htnIcon iconRotate"></CustomeIcon>
                </div>
                <div className="description zoom">
                    <span className="text">ZOOM</span>
                    <CustomeIcon src="./images/zoom.svg" alt="How to navigate - Zoom" classList="htnIcon iconZoom"></CustomeIcon>
                </div>
                <div className="description move">
                    <span className="text">MOVE</span>
                    <CustomeIcon src="./images/move.svg" alt="How to navigate - Move" classList="htnIcon iconMove"></CustomeIcon>
                </div>
            </div>
        </div>

    );
}

export default HowToNavigate;